export enum PersonenRolle {
    Arzt = 'A',
    Assistenz = 'H',
}
